/**
 * @fileoverview Text display component for table cells
 * @active CONFIRMED - This component is actively used in the application
 * 
 * This component renders text content within table cells with consistent styling.
 * It handles text overflow, empty values, and applies consistent typography.
 * 
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/companyInfoTable/CompaniesInfoTableRow.tsx} - Parent row component
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/shared/TdWrapper.tsx} - Table cell wrapper
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/context/TableContext.tsx} - Table context for column widths
 * @see {@link src/components/companies/companiesList/companiesListComponents/tableMain/TableElements.jsx} - Legacy implementation (deprecated)
 */

// src/components/companies/companiesList/newCompaniesList/companiesTable/shared/RowText.tsx

"use client";

import { memo, useContext } from "react";

import { Box, Text, type TextProps } from "@chakra-ui/react";

import TableContext from "../context/TableContext";

interface RowTextProps {
  text?: string;
  idx: number;
  style?: TextProps;
}

const RowText = ({ text, idx, style }: RowTextProps) => {
  const widths = useContext(TableContext);
  return (
    <Text
      fontSize={"14px"}
      fontWeight={"400"}
      lineHeight={"130%"}
      letterSpacing={"4%"}
      textAlign={"center"}
      mb={"-4px"}
      overflow={"hidden"}
      textOverflow={"ellipsis"}
      whiteSpace={"nowrap"}
      maxW={widths?.columnsWidth?.[idx] || "100%"}
      {...style}
    >
      {text || (
        <Box as={"span"} fontSize={"14px"}>
          {"—"}
        </Box>
      )}
    </Text>
  );
};

export default memo(RowText);
